<script lang="ts" setup generic="T">
  //TODO: Remove ts-ignore comments

  import { computed } from 'vue'
  import {
    DEFAULT_TITLE,
    DEFAULT_OPTION_TITLE_KEY,
    DEFAULT_OPTION_CONTENT_KEY,
    OPTION_CLICK_EVENT_NAME,
    DEFAULT_BORDER_COLOR,
    CARD_TITLE_TEST_ID,
    CARD_CONTENT_TEST_ID,
    CARD_BORDER_TEST_ID,
  } from './InformationCard.constants'
  import type { Option, InformationCardVariant } from './InformationCard.types'

  interface Props {
    title: string
    options: Option<T>[]
    optionTitleKey?: string
    optionContentKey?: string
    borderColor?: string
    variant?: InformationCardVariant
  }

  interface Emits {
    (e: typeof OPTION_CLICK_EVENT_NAME, option: Option<T>): void
  }

  const props = withDefaults(defineProps<Props>(), {
    title: DEFAULT_TITLE,
    optionTitleKey: DEFAULT_OPTION_TITLE_KEY,
    optionContentKey: DEFAULT_OPTION_CONTENT_KEY,
    borderColor: DEFAULT_BORDER_COLOR,
  })

  const emit = defineEmits<Emits>()

  const onOptionClick = (option: Option<T>) => {
    if (!option.isClickable) return
    emit(OPTION_CLICK_EVENT_NAME, option)
  }

  const variantClass = computed((): string | undefined => {
    if (props.variant === 'travel') return 'card__color-border--travel'
    return 'card__color-border--custom'
  })
</script>

<template>
  <div class="card">
    <div class="card-title" :data-testid="CARD_TITLE_TEST_ID">
      <span v-if="$slots.icon" class="card-title__icon">
        <slot name="icon"></slot>
      </span>
      <slot name="title">
        <p>
          {{ title }}
        </p>
      </slot>
    </div>
    <ul class="card-options">
      <li
        v-for="option of options"
        :key="
          //@ts-ignore
          option[props.optionTitleKey]
        "
        class="card-option"
      >
        <slot name="option" v-bind="option">
          <span class="card-option__title">
            {{
              //@ts-ignore
              option[props.optionTitleKey]
            }}:
          </span>
          <p class="card-option__content-wrapper">
            <span
              class="card-option__content"
              :class="{ 'card-option__content_clickable': option.isClickable }"
              :data-testid="CARD_CONTENT_TEST_ID"
              @click="onOptionClick(option)"
            >
              {{
                //@ts-ignore
                option[props.optionContentKey]
              }}
            </span>
          </p>
        </slot>
      </li>
    </ul>
    <div class="card__color-border" :class="variantClass" :data-testid="CARD_BORDER_TEST_ID"></div>
  </div>
</template>

<style lang="scss" scoped>
  @import './InformationCard';

  .card__color-border--custom {
    background-color: v-bind('props.borderColor');
  }
</style>
